export const news = [
  {
    id: "news-01",
    date: "2026-10-08",
    title: "《色情男女》4K 修复版重登资料馆",
    summary:
      "该片以电影行业幕后为题材，修复版重新调色后保留了九〇年代的胶片质感，被视为研究当年创作生态的重要文本。",
    movieId: "viva-erotica-1996",
    tag: "修复重映",
  },
  {
    id: "news-02",
    date: "2026-09-30",
    title: "奇案改编类型片专题上新",
    summary:
      "本站在「犯罪惊悚」分类下新增多部取材真实案件的档案条目，梳理该类型片的叙事演变与社会背景。",
    movieId: "the-untold-story-1993",
    tag: "分类更新",
  },
  {
    id: "news-03",
    date: "2026-09-21",
    title: "古装类型片观影指南发布",
    summary:
      "从民间传奇改编到布景美学，本文梳理古装类型片在九〇年代的类型化路径与市场接受度。",
    movieId: "sex-and-zen-1991",
    tag: "专题文章",
  },
  {
    id: "news-04",
    date: "2026-09-12",
    title: "《羔羊医生》幕后访谈档案整理完成",
    summary:
      "档案新增多份当年报刊访谈与制作花絮，呈现导演在纪实叙事与类型娱乐之间的取舍。",
    movieId: "dr-lamb-1992",
    tag: "档案整理",
  },
  {
    id: "news-05",
    date: "2026-09-03",
    title: "都市情感题材片单推荐",
    summary:
      "情侣关系、城市夜景与时代焦虑——本期片单聚焦以都市情感为核心的剧情作品。",
    movieId: "i-am-frantic-1994",
    tag: "片单推荐",
  },
];